import styled from "styled-components";

export const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    font-family: 'Lato', sans-serif;
`;
